"use client"

import type React from "react"
import { useAttributeAccess } from "@/lib/rbac/hooks"

interface ProtectedAttributeProps {
  attributeName: string
  action?: string
  children: React.ReactNode
  fallback?: React.ReactNode
}

export const ProtectedAttribute: React.FC<ProtectedAttributeProps> = ({
  attributeName,
  action,
  children,
  fallback = null,
}) => {
  const hasAccess = useAttributeAccess(attributeName, action)

  if (!hasAccess) {
    return <>{fallback}</>
  }

  return <>{children}</>
}
